import { Card, CardContent } from "@/components/ui/card";
import {
  CalendarIcon,
  CheckCircle2Icon,
  ClockIcon,
} from "lucide-react";

type PromotionsSummaryCardsProps = {
  activeCount: number;
  scheduledToday: number;
  expiringSoon: number;
  isLoading?: boolean;
};

export function PromotionsSummaryCards({
  activeCount,
  scheduledToday,
  expiringSoon,
  isLoading,
}: PromotionsSummaryCardsProps) {
  if (isLoading) {
    return (
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {[1, 2, 3].map((i) => (
          <Card key={i} className="rounded-xl border bg-card">
            <CardContent>
              <div className="h-10 animate-pulse rounded bg-muted" />
              <div className="mt-2 h-6 w-16 animate-pulse rounded bg-muted" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      <Card className="rounded-xl border border-emerald-500/20 bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-emerald-500/10">
            <CheckCircle2Icon className="size-5 text-emerald-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">
              ໂປຣໂມຊັນເປີດໃຊ້ງານ
            </p>
            <p className="font-semibold text-2xl tabular-nums">
              {activeCount.toLocaleString("lo-LA")}
            </p>
          </div>
        </CardContent>
      </Card>

      <Card className="rounded-xl border border-blue-500/20 bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-blue-500/10">
            <CalendarIcon className="size-5 text-blue-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">
              ຕາມຕາຕະລາງວັນນີ້
            </p>
            <p className="font-semibold text-2xl tabular-nums">
              {scheduledToday.toLocaleString("lo-LA")}
            </p>
          </div>
        </CardContent>
      </Card>

      <Card className="rounded-xl border border-amber-500/20 bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-amber-500/10">
            <ClockIcon className="size-5 text-amber-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">
              ໃກ້ຫມົດອາຍຸ
            </p>
            <p className="font-semibold text-2xl tabular-nums">
              {expiringSoon.toLocaleString("lo-LA")}
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
